import React from "react";
import ReactDOM from 'react-dom'
import "../App.css";
import axios from 'axios';
import cross from '../pics/svg/cross.svg'
import Dots from '../pics/svg/dots.svg'
import heart from '../pics/svg/heart.svg'
import full from '../pics/svg/full.svg'
import imdb from '../pics/imdb.png'
import Service from './service';
import Error from '../popups/error'
import Countries from './countries'
import NetflixText from '../pics/services/netflix-text.png'
import Logo from '../pics/logo.png'
import Sad from '../pics/sad.png'
import firebase from 'firebase/app';
import backupImage from '../pics/services/backup.png'
import Message from '../popups/message'

function Show({show}) {

    let services = show.locations,
    countries,
    messageRendered,
    gotCountries = false,
    moreClicked = false,
    sortData = {
        "Netflix": "AAA",
        "Amazon Prime Video": "AAB",
        "Disney+": "AAC",
        "iTunes": "AAD",
        "Google Play": "AAE",
        "TubiIVAUS": "AAF",
        "Amazon Instant Video": "AAG"
    },
    pic = getPic();

    function getPic() {
        let picAttempt
        (show.pic == null) ? (picAttempt = backupImage) : (picAttempt = show.pic)
        return picAttempt
    }

    function getNetflixCountries(show) {
        console.log('fetching countries...')
        const BASE_URL = "https://stormy-savannah-16187.herokuapp.com/api/v1/countries";
        const params = new URLSearchParams({
            show: show.name,
        });
        axios.get(`${BASE_URL}?${params}`)
        .then((response) => {
            gotCountries = true;
            formatResponse(show, response);
        })
        .catch((error) => {
            console.log(error);
        });
    }
    function formatResponse(show, response) {
        let results = response.data.results
        let found;
        results.forEach(res => {
            if (res.imdbid === show.id) {
                if (!found) {
                    countries = tidyCountriesList(res)
                    ReactDOM.render(<Countries countries={countries} id={show.id} />, document.querySelector(`.${show.id} .countries-wrapper`));
                }
                found = true;
            }
        });
        if (!found) {
            results.forEach(res => {
                if (res.title === show.name) {
                    found = true;
                    countries = tidyCountriesList(res)
                    ReactDOM.render(<Countries countries={countries} id={show.id} />, document.querySelector(`.${show.id} .countries-wrapper`));
                }
            });
            if (!found) {
                document.querySelector(`.${show.id} .countries-wrapper .logoload`).style.display = "none"
                document.querySelector(`.${show.id} .countries-wrapper .sad`).style.display = "flex"
            }
        }
    }
    function tidyCountriesList(list) {
        let tidiedList = list.clist.replace(/"/g, "").split(',')
        let i = 0;
        tidiedList.forEach(country => {
            tidiedList[i] = country.slice(3)
            i++;
        });
        return tidiedList
    }

    function alphabetise(a,b) {
        let nameA,
        nameB,
        comparison = 0;
        try {
            nameA = sortData[a.name]
        } catch (error) {
            nameA = a.name
        }
        try {
            nameB = sortData[b.name]
        } catch (error) {
            nameB = b.name
        }

        (nameA < nameB) ? (comparison = -1) : comparison = 1;
        return comparison;
    }

    function showCountries() {
        document.querySelector(`.${show.id} .countries-wrapper`).style.opacity=1
        document.querySelector(`.${show.id} .countries-wrapper`).style.pointerEvents = 'all'
    }

    function hideCountries() {
        document.querySelector(`.${show.id} .banner`).style.display = "flex"
        document.querySelector(`.${show.id} .countries-wrapper`).style.opacity = 0
        document.querySelector(`.${show.id} .countries-wrapper`).style.pointerEvents = 'none'
    }

    function ncClickHandler() {
        showCountries();
        document.querySelector(`.${show.id} .banner`).style.display="none"
        if (!gotCountries) {
            getNetflixCountries(show)
        }
    }

    function fetchCountriesForFav() {
         if (!gotCountries) {
            unogsReq()
        }
    }

    function unogsReq() {
        console.log('fetching countries...')
        const BASE_URL = "https://stormy-savannah-16187.herokuapp.com/api/v1/countries";
        const params = new URLSearchParams({
            show: show.name,
        });
        axios
            .get(`${BASE_URL}?${params}`)
            .then((response) => {
                console.log(response)
                // gotCountries = true
                let results = response.data.results;
                let found;
                try {
                    results.forEach((res) => {
                    if (res.imdbid === show.id) {
                        if (!found) {
                            countries = tidyCountriesList(res);
                            addToFavourites();
                        }
                        found = true;
                    }
                    if (!found) {
                    results.forEach((res) => {
                        if (res.title === show.name) {
                            found = true;
                            countries = tidyCountriesList(res);
                            addToFavourites();
                        }
                    });
                    if (!found) {
                        // Not on any Netflix
                        countries = [];
                        addToFavourites();
                    }
                }
                });
                } catch (error) {
                    console.log(error)
                    countries = [];
                    addToFavourites();
                }
                
                
            })
            .catch((error) => {
                console.log(error);
                countries = [];
            });
    }

    function addToFavourites() {
        let alreadyFav,
            attemptToFind = document.querySelector(`.fav .info .${show.id}`)

        attemptToFind === null ? alreadyFav = false : alreadyFav = true

        alreadyFav ? tellFavAlready() : addToFavs();

    }

    function addToFavs() {
        if (!messageRendered){
            document.querySelector(`.save.${show.id} img`).src = full
            ReactDOM.render(<Message msg={'added to your list!'} />, document.querySelector('.message-container'));
            document.querySelector('.message').classList.add('appear')
            setTimeout(() => {
                document.querySelector('.message').classList.remove('appear')
            }, 2000);
            messageRendered = true
        }
        (countries !== undefined ? saveFav() : fetchCountriesForFav())
        
    }

    function saveFav() {
        let user = firebase.auth().currentUser,
        db = firebase.firestore(),
        newFavourite = {
            name: show.name,
            pic: show.pic,
            services: services,
            id: show.id,
            countries: countries
        };

        if (newFavourite.countries.length > 10) {
            let lastItem = newFavourite.countries[10].replace("e:+", "")
            newFavourite.countries[10] = lastItem + " more!"
        }

        let userRef = db.collection('users').doc(user.uid);
        userRef.get().then(function (doc) {
            if (!doc.exists) {
                // MAKE NEW USER DOC
                userRef.set({
                    favourites: []
                }).then(() =>{
                    userRef.update({
                        favourites: firebase.firestore.FieldValue.arrayUnion(newFavourite)
                    })
                })
            }
            else{
                // USER ALREADY EXISTS
                userRef.update({
                    favourites: firebase.firestore.FieldValue.arrayUnion(newFavourite)
                })
            }
        }).catch(function (error) {
            console.log("Error getting document:", error);
        });
    }

    function onSaveClick() {
        let user = firebase.auth().currentUser;
        user ? addToFavourites() : showLoginWrapper()
    }

    function showLoginWrapper() {
        document.querySelector('.login-wrapper').style.transform = "scale(1)"
        document.querySelector('.login-wrapper').style.opacity = 1
        document.querySelector('.login-wrapper').style.pointerEvents = "all"
        document.querySelector('button.Login').style.pointerEvents = "all"
    }

    function tellFavAlready() {
        let error = {
            code: `${show.name}'s already one of your favourites!`
        }
        ReactDOM.render(<Error oops={error} />, document.querySelector('.error-container'));
        document.querySelector('.error').classList.add('show')
        setTimeout(() => {
            document.querySelector('.error').classList.remove('show')
        }, 7000);
    }
    
    function onMoreClicked() {
        moreClicked ? showMore() : hideMore()
        moreClicked = !moreClicked
    }

    function hideMore() {
        document.querySelector(`.nc-container.${show.id}`).style.display = "none"
        document.querySelector(`.nc-container.${show.id}`).style.opacity = "0"
        document.querySelector(`.imdb-mobile.${show.id}`).style.display = "none"
        document.querySelector(`.imdb-mobile.${show.id}`).style.opacity = "0"
        document.querySelector(`.save.${show.id}`).style.display = "none"
        document.querySelector(`.save.${show.id}`).style.opacity = "0"
        document.querySelector(`.show.${show.id}`).style.paddingBottom = "10px"
    }
    function showMore() {
        document.querySelector(`.nc-container.${show.id}`).style.display = "flex"
        document.querySelector(`.nc-container.${show.id}`).style.opacity = "1"
        document.querySelector(`.imdb-mobile.${show.id}`).style.display = "flex"
        document.querySelector(`.imdb-mobile.${show.id}`).style.opacity = "1"
        document.querySelector(`.save.${show.id}`).style.display = "flex"
        document.querySelector(`.save.${show.id}`).style.opacity = "1"
        document.querySelector(`.show.${show.id}`).style.paddingBottom = "90px"
    }

    services.sort(alphabetise)
    
    if (window.innerWidth < 600) {
        setTimeout(() => {
            onMoreClicked()
        }, 200);
    }
    
    return (
        <div className={`show ${show.id}`}>
            <a className='imdb' href={`https://www.imdb.com/title/${show.id}`} target="_blank" rel="noopener noreferrer">
                <img className="pic" src={pic} alt={show.name} />
                <img className="logo" src={imdb} alt="imdb"/>
            </a>
            <div className={`nc-container ${show.id}`}>
                <button onClick={ncClickHandler} className="nc">
                    <img src={NetflixText} alt="netflix" />
                    <span role="img" aria-label="earth">🌍</span>
                </button>
                <div className="banner">check international netflix</div>
                <div className={`countries-wrapper`}>
                    <img className="cross" onClick={hideCountries} src={cross} alt="X" />
                    <img className='logoload' src={Logo} alt="loading"/>
                    <div className="sad">
                        <img src={Sad} alt=""/>
                        sorry!<br/>
                        couldn't find that on netflix
                    </div>
                </div>
            </div>
            <button onClick={onSaveClick} className={`save ${show.id}`}>
                <img src={heart} alt="heart" />
            </button>
            <a href={`https://www.imdb.com/title/${show.id}`} className={`imdb-mobile ${show.id}`}>
                <img className="imdb-logo" src={imdb} alt="imdb" />
            </a>
            <div className="info">
                <div className="top">
                    <h3>{show.name}</h3>
                    <div className="more">
                        <img onClick={onMoreClicked} src={Dots} alt="more..."/>
                    </div>
                </div>
                <div className="services">
                    {services.map((service) => (
                        <Service key={service.name} service={service}/>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Show;
